var modules_ef1f9f15 = {"tabs":"Tabs_module_tabs__af0fd544","panes":"Tabs_module_panes__af0fd544","tab":"Tabs_module_tab__af0fd544","view-text":"Tabs_module_viewText__af0fd544","color-gray":"Tabs_module_colorGray__af0fd544","color-light":"Tabs_module_colorLight__af0fd544","active":"Tabs_module_active__af0fd544","color-dark":"Tabs_module_colorDark__af0fd544","pane":"Tabs_module_pane__af0fd544"};
import "../../../assets/esm/components/Tabs/src/TabPane~C0Rt0bVf.css";

export { modules_ef1f9f15 as default };
//# sourceMappingURL=Tabs.module.less.js.map
